/**
 * Language: Hungarian.
 */
export default {
    time: {
        openingHoursTitle: "Nyitvatartási idő",
        at: "itt",
	to: "erre",
        opensToday: "Ma nyitva van",
        opens: "Nyitás",
        open24_7: "Nyitva 24/7",
        closed: "Zárva",
        openUntil: "Nyitvatartásig",
        daily: "Naponta",
        month: [
            'Január', 'Február', 'Március', 'Április', 'Május', 'Június',
            'Július', 'Augusztus', 'Szeptember', 'Október', 'November', 'December'
        ],
        monthAbbr: [
            'Jan.', 'Febr.', 'Márc.', 'Ápr.', 'Máj.', 'Jún.',
            'Júl.', 'Aug.', 'Szept.', 'Okt.', 'Nov.', 'Dec.'
        ],
        dayOfWeek: [
            'Hétfő', 'Kedd', 'Szerda', 'Sütörtök', 'Péntek', 'Szombat','Vasárnap', 
        ],
        dayOfWeekAbbr: [
            'Hét', 'Ked', 'Sze', 'Csü', 'Pén', 'Szo','Vas', 
        ],
        temporarilyClosed: "Átmenetileg zárva",
        opened: "",
        today: ""
    },
    search: {
        placeholder: "Utca, város, vagy irányítószám",
        submitLabel: "Keresés",
        clearLabel: "Keresés törlése",
        yourLocation: "A te helyzeted",
    },
    filtering: {
        servicesTitle: "Szolgáltatások",
        services: {
            WF: 'Vezeték nélküli Hotspot',
            CD: 'Mobilfizetés',
            DT: 'Autós kiszolgálás',
            DR: 'Digitális jutalmak',
            hrs24: 'Naponta 24 órában nyitva',
            WA: 'Sütőben melegített ételek',
            LB: 'LaBoulange',
            XO: 'Mobil Rendelés és Fizetés',
            VS: 'Verismo',
            NB: 'Nitro hideg kávé',
            CL: 'Starbucks Reserve-Clover főzésű',
        }
    },
    stores: {
        cta: {
            call: "Hívás",
            directions: "Útvonalterv",
            website: "Weboldal",
            'club details': 'Club details',
            'view tariffs': 'Join now',
            'View Map': "Térkép megtekintése",
            'View List': "Lista megtekintése"
        },
        messages: {
            initialHeader: "Találd meg a közeledben lévő clubot/clubokat a kereső segítségével",
            emptyHeader: "Nincs club a közelben",
            initialBody: "vagy kattints a térképre egy club kiválasztásához",
            emptyBody: "Kérjük, keress egy másik helyet, vagy töröld a szűrőket"
        }
    },
    directions: {
        avoidOptions: {
            highways: 'Autópályák',
            tolls: 'Fizetőkapuk',
            ferries: 'Kompok'
        },
        unitOptions: {
            METRIC: 'km',
            IMPERIAL: 'mérföld'
        },
        options: "Útvonal opciók",
        avoid: "Elkerülni",
        units: "Távolság mértékegységek",
        messages: {
            initialBody: "Keresse meg a kiindulópontot és a célállomást, hogy megtekinthesse az elérhető útvonalakat és az utazási időt.",
            error: "Sajnáljuk, nem sikerült kiszámítani az útvonalat",
            from: "itt:",
            to: "ide:",
            forTravelMode: "az utazási módhoz:",
            via: "keresztül",
            details: "Részletek",
            withoutTraffic: "a forgalom figyelembevétele nélkül",
            openGoogleMaps: "megnyitása a Google Térképen"
        }
    },
    errors: {
        loadingLibrary: "{library} script betöltése sikertelen",
        geolocationFailed: "Felhasználói földrajzi helymeghatározás sikertelen",
        apiErrors:{
            "401": "Engedély nélküli hozzáférés",
            "403": "Tiltott hozzáférés",
            "429": "Túl sok kérés",
            "500": "Belső szerverhiba",
            other: "Váratlan szerverhiba történt"
        }
    },
};
